import React, {FC} from 'react';

import {PRODUCT_TYPES} from 'constants/product';

import {CheckoutItemType} from 'desktop/types/checkoutItemsType';

import {logWithSentry} from 'libs/sentry/sentry';

import s from './cartItemQty.scss';

type PropsType = {
    item: CheckoutItemType;
};

/**
 * Cart Item Qty for checkout page
 *
 * @constructor
 */
export const CartItemQty: FC<PropsType> = ({item}) => {
    let quantity = '';
    try {
        quantity =
            item.product.type === PRODUCT_TYPES.CONTACT_LENSES && item.prescription
                ? `${item.prescription.od.boxes}+${item.prescription.os.boxes}`
                : `${item.qty}`;
    } catch (e) {
        logWithSentry(e, {item});
    }

    return (
        <>
            Qty: <span className={s.qty}>{quantity}</span>
        </>
    );
};
